import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3.33333 13.3333L3.33333 14.1667C3.33333 15.5474 4.45262 16.6667 5.83333 16.6667L14.1667 16.6667C15.5474 16.6667 16.6667 15.5474 16.6667 14.1667L16.6667 13.3333M13.3333 6.66666L9.99999 3.33333M9.99999 3.33333L6.66666 6.66666M9.99999 3.33333L9.99999 13.3333" />
  </svg>
);
